'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureTwitterAdsPixel;

var _scriptLoader = require('./script-loader.js');

var _scriptLoader2 = _interopRequireDefault(_scriptLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function configureTwitterAdsPixel(_ref) {
  var config = _ref.config,
      handlers = _ref.handlers,
      window = _ref.window,
      document = _ref.document;

  var promise = Promise.resolve();

  if (config.preloaded) {
    var src = 'https://static.ads-twitter.com/uwt.js';
    var stub = function stub() {
      stub.exe ? stub.exe.apply(stub, arguments) : stub.queue.push(arguments);
    };

    stub.version = '1.1';
    stub.queue = [];

    promise = (0, _scriptLoader2.default)({ src: src, globalName: 'twq', stub: stub, window: window, document: document });
    window.twq('init', config.id);
  }

  handlers.push(handleEvent.bind(null, config.mappings));

  return promise;
}

function handleEvent(mappings, _ref2) {
  var type = _ref2.type,
      id = _ref2.id,
      properties = _ref2.properties;

  if (type === 'page') {
    return window.twq('track', 'PageView');
  }

  if (type === 'track') {
    return (mappings || []).filter(function (mapping) {
      return mapping.evt === id;
    }).forEach(function (mapping) {
      return window.twttr.conversion.trackPid(mapping.pid, properties);
    });
  }

  return null;
}


//////////////////
// WEBPACK FOOTER
// ./~/auth0-tag-manager/lib/twitter-ads-pixel.js
// module id = 8
// module chunks = 0